import { Add, Delete, Edit } from '@mui/icons-material';
import {
  Box,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { useState, type Dispatch, type SetStateAction } from 'react';
import { ILegalClientFullObject } from '../../Interfaces/ILegalClient';
import {
  ILegalClientContactInformationType,
  type ILegalClientContactInformation,
} from '../../Interfaces/ILegalClientContactInformation';
import { UpdateOrCreateContactInformationDialog } from './UpdateOrCreateContactInformationDialog';

interface IProps {
  contactInformationTypes: ILegalClientContactInformationType[];
  formValues: ILegalClientFullObject;
  setFormValues: Dispatch<SetStateAction<ILegalClientFullObject>>;
}

export const ContactInformationTab = ({
  contactInformationTypes,
  formValues,
  setFormValues,
}: IProps) => {
  const [isMount, setIsMount] = useState(false);
  const [selectedContactInformation, setSelectedContactInformation] =
    useState<ILegalClientContactInformation>();

  const onAdd = (contactInformation: ILegalClientContactInformation) =>
    setFormValues(prev => ({
      ...prev,
      ContactInformationArray: [
        ...prev.ContactInformationArray,
        contactInformation,
      ],
    }));

  const onRemove = (contactInformationId: number) =>
    setFormValues(prev => ({
      ...prev,
      ContactInformationArray: prev.ContactInformationArray.filter(
        ci => ci.idContactInformation !== contactInformationId
      ),
    }));

  const onUpdate = (contactInformation: ILegalClientContactInformation) => {
    setFormValues(prev => ({
      ...prev,
      ContactInformationArray: prev.ContactInformationArray.map(ci =>
        ci.idContactInformation === contactInformation.idContactInformation
          ? contactInformation
          : ci
      ),
    }));

    setSelectedContactInformation(undefined);
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant='h5'>Kontaktinformationen</Typography>
        <Tooltip title='Kontakt hinzufügen'>
          <IconButton onClick={() => setIsMount(true)}>
            <Add />
          </IconButton>
        </Tooltip>
      </Box>
      <Grid container spacing={2} mt={1}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Art</TableCell>
              <TableCell>Kontakt</TableCell>
              <TableCell sx={{ width: 150 }}>Aktionen</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {formValues.ContactInformationArray.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4}>
                  <i>Keine Kontaktinformationen vorhanden.</i>
                </TableCell>
              </TableRow>
            ) : (
              formValues.ContactInformationArray.map((ci, i) => (
                <TableRow key={i}>
                  <TableCell>{ci.ContactInformationType}</TableCell>
                  <TableCell>{ci.Contact}</TableCell>
                  <TableCell>
                    <IconButton
                      onClick={() => {
                        setSelectedContactInformation(ci);
                        setIsMount(true);
                      }}
                    >
                      <Edit />
                    </IconButton>
                    <IconButton
                      onClick={() => onRemove(ci.idContactInformation)}
                    >
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Grid>
      {isMount && (
        <UpdateOrCreateContactInformationDialog
          selectedContactInformation={selectedContactInformation}
          contactInformationTypes={contactInformationTypes}
          unmount={() => {
            setSelectedContactInformation(undefined);
            setIsMount(false);
          }}
          onSave={!!selectedContactInformation ? onUpdate : onAdd}
        />
      )}
    </Box>
  );
};
